import React from 'react';
import {
    Tab,
    Tabs as MuiTabs,
    Typography,
    Box,
    makeStyles,
    createStyles,
    useTheme,
} from '@material-ui/core';
import styled from 'styled-components';
import { TabValue } from '~/src/types';

const useTabStyles = makeStyles(() =>
    createStyles({
        label: {
            fontSize: '14px',
            fontWeight: 'bold',
            textTransform: 'uppercase',
            lineHeight: '125%',
        },
    }),
);

export const SCTab = styled(Tab)`
    padding: 1rem 0;
    margin: 0 0.75rem;
    min-width: 0px;
`;

interface TabsProps {
    tabs: TabValue[];
    activeTab: string;
    setTab: React.Dispatch<React.SetStateAction<string>>;
}

const Tabs: React.FC<TabsProps> = ({ tabs, activeTab, setTab }) => {
    const theme = useTheme();
    const classes = useTabStyles();
    const handleTabsChange = (event: React.ChangeEvent, newValue: string) => {
        setTab(newValue);
    };

    return (
        <Box my={3}>
            <MuiTabs
                value={activeTab}
                TabIndicatorProps={{
                    style: {
                        backgroundColor: theme.palette.primary.main,
                        height: '0.25rem',
                        maxWidth: '6.875rem',
                    },
                }}
                onChange={handleTabsChange}
                centered
            >
                {tabs &&
                    tabs.map(tab => (
                        <SCTab
                            key={tab.index}
                            value={tab.value}
                            label={
                                <Typography className={classes.label} variant="body1">
                                    {tab.label}
                                </Typography>
                            }
                        />
                    ))}
            </MuiTabs>
        </Box>
    );
};

export default Tabs;
